import type { ReviewTileItem, SearchResult } from "@/types/tile.types";

export const TILE_SEARCH_FIELDS: (keyof ReviewTileItem)[] = [
  "clause",
  "reason",
  "analysis",
  "explanation",
];

export function normalizeTextWith(text: string, caseSensitive: boolean): string {
  if (!caseSensitive) text = text.toLowerCase();
  return text.trim();
}

function escapeRegExpChars(term: string): string {
  return term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function findWholeWordMatches(
  normalizedText: string,
  normalizedTerm: string,
  caseSensitive: boolean
): { startIndex: number; endIndex: number }[] {
  const matches: { startIndex: number; endIndex: number }[] = [];
  const escapedTerm = escapeRegExpChars(normalizedTerm);
  const regex = new RegExp(`\\b${escapedTerm}\\b`, caseSensitive ? "g" : "gi");
  let match;
  while ((match = regex.exec(normalizedText)) !== null) {
    matches.push({ startIndex: match.index, endIndex: match.index + match[0].length });
  }
  return matches;
}

export function findSubstringMatches(
  normalizedText: string,
  normalizedTerm: string
): { startIndex: number; endIndex: number }[] {
  const matches: { startIndex: number; endIndex: number }[] = [];
  let startIndex = 0;
  while (true) {
    const index = normalizedText.indexOf(normalizedTerm, startIndex);
    if (index === -1) break;
    matches.push({ startIndex: index, endIndex: index + normalizedTerm.length });
    startIndex = index + (normalizedTerm.length > 0 ? normalizedTerm.length : 1);
  }
  return matches;
}

export function collectTileMatches(
  tile: ReviewTileItem,
  searchTerm: string,
  findMatches: (text: string, term: string) => { startIndex: number; endIndex: number }[]
): { tileMatches: SearchResult["matches"]; totalMatches: number } {
  const tileMatches: SearchResult["matches"] = [];
  let totalMatches = 0;

  for (const field of TILE_SEARCH_FIELDS) {
    const fieldValue = tile[field];
    if (typeof fieldValue === "string" && fieldValue) {
      const matches = findMatches(fieldValue, searchTerm);
      if (matches.length > 0) {
        tileMatches.push({
          field,
          text: fieldValue,
          startIndex: matches[0]?.startIndex ?? 0,
          endIndex: matches[0]?.endIndex ?? 0,
        });
        totalMatches += matches.length;
      }
    }
  }

  return { tileMatches, totalMatches };
}
